import { render, staticRenderFns } from "./ForumThread.vue?vue&type=template&id=50ac41fd&scoped=true&"
import script from "./ForumThread.vue?vue&type=script&lang=js&"
export * from "./ForumThread.vue?vue&type=script&lang=js&"
import style0 from "./ForumThread.vue?vue&type=style&index=0&id=50ac41fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac41fd",
  null
  
)

export default component.exports